export default __webpack_public_path__ + "static/media/illo-dots.af60fd0f.webp";